import { FC } from 'react';
import { observer } from 'mobx-react';

import StaticFrame from '../../../Frames/StaticFrame/StaticFrame';
import { QuestionSessionBodyPresentationProps } from '../config';

/**
 * An instruction asks nothing: it is a page the user reads and continues from.
 * It is drawn by the static-frame presenter — the same centred title, picture
 * and paragraph as a FRAME step — so there is one presentation to maintain
 * rather than a second, plainer one. The question keeps its own data model:
 * its wording becomes the title and its description the paragraph.
 */
const _PresentInstruction: FC<QuestionSessionBodyPresentationProps> = ({
  questionText,
  questionDescription,
  questionImage,
  loading,
}) => (
  <StaticFrame
    loading={loading}
    staticFrame={{
      type: 'tit_pic_xText',
      mainTitle: questionText || '',
      secondaryTitle: questionDescription || '',
      image: questionImage || '',
    }}
  />
);

export const PresentInstruction = observer(_PresentInstruction);
